/**
 * PerfectScrollbar 容器的 scrollHeight 會被絕對定位 rail 暫時撐高；
 * 內容收合時若用 scrollHeight 算底部，會出現「下方大片空白、scrollTop 慢慢收回」。
 * 應以內容區塊（contentRef 或 .ps__content）的實際高度計算 maxTop。
 */

export function resolvePerfectScrollbarContentEl(container, contentEl) {
  if (contentEl) return contentEl;
  if (!container) return null;
  return (
    container.querySelector(":scope > .ps__content") ||
    container.firstElementChild
  );
}

export function getPerfectScrollbarMaxTop(container, contentEl) {
  if (!container) return 0;
  const content = resolvePerfectScrollbarContentEl(container, contentEl);
  if (content) {
    const contentBottom = content.offsetTop + content.offsetHeight;
    return Math.max(0, contentBottom - container.clientHeight);
  }
  return Math.max(0, container.scrollHeight - container.clientHeight);
}

/** 主動下捲／捲到底：content 量測偏低時仍尊重 scrollHeight */
export function getPerfectScrollbarScrollExtentMaxTop(container, contentEl) {
  if (!container) return 0;
  const fromContent = getPerfectScrollbarMaxTop(container, contentEl);
  const fromScrollHeight = Math.max(
    0,
    container.scrollHeight - container.clientHeight
  );
  return Math.max(fromContent, fromScrollHeight);
}

/** 內容變矮後立刻 clamp，避免瀏覽器平滑拉回 scrollTop */
export function clampPerfectScrollbarOverflow(container, contentEl) {
  if (!container) return false;
  const maxTop = getPerfectScrollbarMaxTop(container, contentEl);
  if (container.scrollTop > maxTop + 0.5) {
    container.style.scrollBehavior = "auto";
    container.scrollTop = maxTop;
    return true;
  }
  return false;
}
